import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { config } from '../config.js'
import {
  Grid,
  Paper,
  Link,
} from '@material-ui/core'
import AppTopBar from '../components/AppTopBar'
import { Skeleton } from "@material-ui/lab"
import { withStyles } from '@material-ui/core/styles'
import { startCase } from 'lodash'
import Helmet from 'react-helmet'

const API = config.api.TRAVEL_URL

class Sitemap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      links: [],
      isLoading: false,
      name: (this.props.name === undefined || this.props.name === 'where-to-go' ? '' : this.props.name),
      headline: this.props.name || 'where-to-go',
      subtitle: 'Discover destinations based on your interest',
      page_banner_image: '',
      country: this.props.country || '',
      pages: 1,
      page: this.props.page || 1,
    }
    window.gtag('event', 'sitemap', {group: this.state.headline});
  }

  componentDidMount() {
    this.getDestinations()
  }

  getDestinations = () => {
    this.setState({isLoading: true})

    fetch(API + '/sitemap' +
          (this.props.name === undefined || this.props.name === 'where-to-go' ? '' : '/' + this.props.name) +
          '?page=' + (this.props.page || 1) +
          (this.props.country && this.props.country !== '' ? '&country=' + this.props.country : '') ,
    {
      headers: {
        'X-USER': this.props.user_id
      }
    })
    .then(response => response.json())
    .then(data => {
      this.setState(prevState => ({
        links: data.links || [],
        pages: data.pages || 1,
        isLoading: false,
      }))
    })
  }

  render() {
    const { classes } = this.props

    return (
      <Fragment>
        <Helmet>
          <title>{`${startCase(this.state.headline)}`}</title>
        </Helmet>
        <AppTopBar
            onLocationChanged={this.props.onLocationChanged}
            onLocationCleared={this.props.onLocationCleared}
            onChange={this.props.onFilterChange}
            onSignin={this.props.onSignin}
            user={this.props.user}
            address={startCase(this.props.address)}
        />

        {/* <AppBar position="static"  className={classes.appbar}>
          <Toolbar className={classes.toolbar}>
            <ButtonBase className="logo" onClick={this.handleHomeRedirect} name="Logo">
              Travelities
            </ButtonBase>
          </Toolbar>
        </AppBar> */}

        <div className="destinations">
          <div className="destinations-container">
            <Paper className={classes.headlinePaper} style={{backgroundImage: `url(${this.state.page_banner_image ? this.state.page_banner_image : ''})`, margin: '-15px', width: '100vw'}} square>
              <h2 className={classes.headline}>
                <br/><br/>

                {this.state.isLoading ? (
                  <Fragment>
                    <strong style={{fontSize: '25px', fontWeight: 800}}>
                      {startCase(this.state.headline)}
                      <br/>
                    </strong>
                    <small style={{color: '#828282'}}>
                      <Skeleton variant="rect" height={20} width={'50%'} style={{marginTop: '15px'}}/>
                      <br/><br/>
                    </small>
                  </Fragment>
                ) : (
                  <Fragment>
                    <strong style={{fontSize: '25px', fontWeight: 800}}>{startCase(this.state.headline)}<br/></strong>
                    <small style={{color: '#828282', fontWeight: 600, fontSize: '70%'}}>
                      {(this.props.country && this.props.country !== '' ? `from ${startCase(this.props.country)}` : this.state.subtitle)}
                      <br/><br/>
                    </small>
                  </Fragment>
                )}

              </h2>
            </Paper>

            <div className={classes.linksContainer}>
              <Grid container xs={12} sm={12} md={12} className={classes.gridFilters}>
                {this.state.links.map((item, index) => {
                  return (
                    <Grid item xs={6} sm={6} md={4} key={index}>
                      <Link className={classes.link} href={item.link}>
                        {item.title}
                      </Link>
                    </Grid>
                  )
                })}
              </Grid>

              <br/><br/>
              <Grid container xs={12} sm={12} md={12} className={classes.gridFilters}>
                {this.state.pages > 1 && [...new Array(this.state.pages - 1)].map((item, index) => {
                  return (
                    <Link className={classes.link} href={`/sitemap/${this.props.name}${this.props.country && this.props.country !== '' ? `/from/${this.props.country}` : ''}/p/${index + 1}`}>
                      {index+1}
                    </Link>
                  )
                })}
              </Grid>
            </div>

          </div>
        </div>
      </Fragment>
    )
  }
}

const styles = {
  linksContainer: {
    padding: 20
  },
  categoryContainer: {
    height: 160,
    display: 'block',
    overflowX: 'scroll',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    marginLeft: '-10px',
  },
  destinationsContainer: {
    margin: '0px -8px',
  },
  button: {
    margin: '20px auto',
    display: 'block',
    width: '100%',
    backgroundColor: '#eee',
    boxShadow: 'none',
    color: '#333',
    textAlign: 'center',

    '&:hover': {
      backgroundColor: '#ddd',
    }
  },
  appBar: {
    backgroundColor: '#fff',
    zIndex: 10,
    display: 'block',
    position: 'relative',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02)',
  },
  menuButton: {
    color: '#333',
  },
  interestsContainer: {
    textAlign: 'left',
    padding: '0px 0px 0px 0px',
    fontSize: '15px',
    color: '#777',
    width: 'calc(100% + 10px)',
  },
  gridFilters: {
    textAlign: 'left',
    maxWidth: 1130,
    margin: '0px auto',
  },
  progressPrimary: {
    backgroundColor: '#e0e0e0',
    height: '2px'
  },
  progressBarColor: {
    backgroundColor: '#00bc30'
  },
  progress: {
    flexGrow: 1,
    width: '100%',
    float: 'left',
    clear: 'both',
    margin: '27px 0px 0px 0px',
    position: 'absolute',
    left: 0,
  },
  paperHeader: {
    width: 'auto',
    // border: ' 1px solid #eee',
    // marginBottom: 10,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    // top: 64,
    margin: '0px auto',
    maxWidth: 1130,
    // borderRadius: 0,
    padding: '0px 2px 1px 2px',
  },
  iconSort: {
    padding: '0 !important',
    fontSize: 18,
    marginTop: -3,
    marginRight: 5,
  },
  actions: {
    float: 'right',
    marginTop: 4,
  },
  buttonSort: {
    color: '#444',
    textTransform: 'capitalize',
    border: '1px solid #eee',
    fontWeight: 400,
    fontSize: 12,
    height: 40,
    // backgroundColor: '#eee',
  },
  tripOrigin: {
    color: '#444',
    textTransform: 'capitalize',
    textAlign: 'left',
    border: '1px solid #eee',
    fontWeight: 400,
    backgroundColor: '#eee',
    fontSize: 12,
    height: 40,
    verticalAlign: 'top',
    padding: '1px 8px 0px 8px',
  },
  iconTripOrigin: {
    padding: '0 !important',
    fontSize: 18,
    marginTop: -3,
    marginRight: 5,
  },
  filters: {
    // position: 'fixed',
    top: 64,
    margin: '0px auto',
    backgroundColor: '#fff',
    zIndex: 90,
    borderRadius: 0,
    width: '100%',
    display: 'block',
    left: 0,
    position: 'relative',
    // borderTop: '1px solid #eee',
    // boxShadow: '0px 0px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02)',
  },
  headlinePaper: {
    padding: ' 20px 0px 65px 0px',
    margin: '-10px auto 0px auto',
    color: '#333',
    textAlign: 'left',
    width: '100%',
    minHeight: '25vh',
    position: 'relative',
    boxShadow: 'none',
    backgroundColor: '#fafafa',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
  headline: {
    maxWidth: 1119,
    width: '90vw',
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: '20px',
    fontWeight: 400,
    padding: '50px 20px 20px 20px',
  },
  toolbar: {
    maxWidth: 1119,
    width: '100%',
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: '20px',
    fontWeight: 400,
  },
  appbar: {
    width: '100%',
    position: 'relative',
    backgroundColor: '#fff !important',
    boxShadow: '0px 1px 20px 0px rgba(0,0,0,0.2), 0px -18px 2px 0px rgba(0,0,0,0.14), 0px -4px 1px -2px rgba(0,0,0,0.12)',
  },
  paperBox: {
    width: '100%',
    // border: ' 1px solid #eee',
    marginTop: -71,
    zIndex: 10,
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
  },
  searchDestination: {
    margin: 0,
    lineHeight: '20px',
    padding: '5px',
    fontWeight: 600,
    borderBottom: '1px solid #eee',
    position: 'relative',
  },
  subtitle: {
    fontWeight: 400,
    fontSize: '70%',
    color: '#777',
    display: 'block',
  },
  notFoundContainer: {
    marginTop: 50,
    textAlign: 'center',
  },
  notFound: {
    display: 'block',
    margin: 'auto',
    maxWidth: '300px',
    minWidth: '200px',
    width: '50%',
    padding: 30,
  },
  homepageBtn: {
    margin: 0,
    backgroundColor: '#17ad41',
    color: '#fff',
    fontWeight: 500,
    borderRadius: '4px',

    '&:hover': {
      backgroundColor: '#139036',
    }
  },
  root: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.87)',
    display: 'inline-flex',
    position: 'relative',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    lineHeight: '1.4em',
    marginRight: 10,
    marginTop: 5,
    textAlign: 'left',
  },
  cardRoot: {
    width: '100%'
  },
  media: {
    height: '370px',
    margin: '-25px -25px -25px -25px',
  },
  titleWeekly: {
    padding: '20px 40px 20px 20px',
    width: '70px',
    display: 'block',

    '& h5': {
      fontSize: '22.5px',
      fontWeight: 700,
    },
  },
  subtitleWeekly: {
    fontSize: '17px',
    fontWeight: 400,
  },
  buttonWeekly: {
    color: '#fff',
    marginTop: '20px',
    fontSize: '17px',
    marginBottom: '30px',
    textDecoration: "none",

    "&:hover": {
      textDecoration: "none",
    }
  },
  link: {
    textDecoration: "none",
    fontWeight: 400,
    color: '#333',
    textAlign: 'left',
    padding: '20px',
    display: 'block',

    "&:hover": {
      textDecoration: "none",
    }
  },
}

export default withRouter(withStyles(styles)(Sitemap))
